import { AppHTTPService } from '../http-service'

export const deleteAgent = async (params: { environmentId: string; agentId: string }): Promise<any> => {
  return AppHTTPService.axios
    .delete(`/v1/agents/${params.agentId}`, { params: { environmentId: params.environmentId } })
    .then((res) => {
      return res.data
    })
}

export const createAgent = async (params: { environmentId: string; agentConfig: any }): Promise<any> => {
  return AppHTTPService.axios
    .post('/v1/agents', { ...params.agentConfig }, { params: { environmentId: params.environmentId } })
    .then((res) => {
      return res.data
    })
}

export const getAgentVersions = async (agentId: string): Promise<{ data: AgentVersion[] }> => {
  return AppHTTPService.axios.get(`/v1/agents/${agentId}/versions`).then((res) => {
    return res.data
  })
}

export const revertToVersion = async (params: {
  agentId: string
  agentVersionId: string
}): Promise<{ data: AgentVersion[] }> => {
  return AppHTTPService.axios
    .post(`/v1/agents/${params.agentId}/versions/${params.agentVersionId}/revert`)
    .then((res) => {
      return res.data
    })
}

export const listAgents = async (params: {
  environmentId: string
  isSystem?: boolean
  search?: string
}): Promise<{ data: any[] }> => {
  const processedParams = { ...params }

  if (params.search) {
    const match = params.search.match(/^[a-z]+_ag_(.+)$/)
    if (match) {
      processedParams.search = match[1]
    }
  }

  return AppHTTPService.axios.get('/v1/agents', { params: processedParams }).then((res) => {
    return res.data
  })
}

export interface AgentVersion {
  agent_id: string
  compiler: string
  createdAt: string
  description?: string
  driver: string
  driver_settings: Record<string, any>
  id: string
  path: string
  topics: string[]
  updatedAt?: string
  version: number
  origin?: number
}
